import DataLoader, {
  years,
  factors,
  defaultCountry,
  defaultFactor,
  defaultYear,
} from "../DataLoader"

export default function getSelectionsFromParams(params) {
  let selectedYear = defaultYear
  let selectedCountry = defaultCountry
  let selectedFactor = defaultFactor
  const opts = []
  if ("opt1" in params) {
    opts.push(params.opt1)
  }
  if ("opt2" in params) {
    opts.push(params.opt2)
  }
  if ("opt3" in params) {
    opts.push(params.opt3)
  }
  if ("opt4" in params) {
    opts.push(params.opt4)
  }
  const unusedOpts = []
  opts.forEach((optEncoded) => {
    if (!optEncoded) {
      return
    }
    const opt = decodeURIComponent(optEncoded)
    if (years.includes(opt)) {
      selectedYear = opt
      return
    }
    // dataByYear is empty while the CSVs are still loading
    const countries = DataLoader.dataByYear?.[selectedYear]?.countries ?? []
    if (countries.map((d) => d.Country).includes(opt)) {
      selectedCountry = opt
      return
    }
    if (factors.includes(opt)) {
      selectedFactor = opt
      return
    }
    unusedOpts.push(opt)
  })

  return { selectedCountry, selectedYear, selectedFactor, unusedOpts }
}
